export const GridLoadingSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
}

export const CameraSx = {
    width: '100%',
    height: '100%'
}

export const containerCameraIconSx = {
    position: 'absolute',
    bottom: '5px',
    right: '5px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    maxWidth: '98%'
}

export const cameraIconSx = {
    cursor: 'pointer',
    color: 'white'
}

export const linkCameraIcon = {
    display: 'flex'
}

const textoCamera = {
    maxWidth: '98%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
}

export const textoCameraPrincipalSx = {
    ...textoCamera
}

export const textoCameraSecundariaSx = {
    ...textoCamera,
    fontSize: '0.6rem',
    textAlign: 'end'
}

export const playIconSx = {
    position: 'absolute',
    width: '40%',
    height: '40%',
    top: '30%',
    left: '30%'
}

export const noCameraIconSx = {
    position: 'absolute',
    width: '20%',
    height: '20%',
    top: '40%',
    left: '40%'
}

export const relativeGridSx = {
    height: '100%',
    position: 'relative'
}
